export const obfuscatedSymbol = Symbol();



// WEBPACK FOOTER //
// ./src/lib/redux-stabilizer/symbol.ts